/* eslint-disable max-len */
import api from '@/services/api';

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    getMarketChartData({ commit }, params) {
      return api.chart.getMarketChartData(params)
        .then(response => response.data);
    },
    getContractChartData({ commit }, { contractId, timeline }) {
      return api.chart.getContractChartData(contractId, timeline)
        .then(response => response.data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/chart.js